"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PressOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M24.3,14.47l-6.13-.78V8.53a3.46,3.46,0,1,0-6.91,0V19.25c-1-.45-1.79-.82-1.94-.88A3.45,3.45,0,0,0,5.4,19.56a3.39,3.39,0,0,0-.65,2.56A3.45,3.45,0,0,0,6.09,24.4l6.55,4.91a3.46,3.46,0,0,0,2.08.69h9.57a2.64,2.64,0,0,0,2.62-2.31L28,19.24A4.3,4.3,0,0,0,24.3,14.47ZM26,19l-1.05,8.45a.65.65,0,0,1-.64.56H14.72a1.47,1.47,0,0,1-.88-.29L7.29,22.79a1.46,1.46,0,0,1-.57-.95A1.48,1.48,0,0,1,7,20.76a1.45,1.45,0,0,1,1.17-.59,1.6,1.6,0,0,1,.47.08c.2.08,1.8.82,3.2,1.47l1.42.66V8.53a1.46,1.46,0,1,1,2.91,0v6.93l7.86,1A2.27,2.27,0,0,1,26,19Z"/><path d="M9.31,12a.9.9,0,0,0,.38-.08,1,1,0,0,0,.54-1.3,4.79,4.79,0,1,1,8.85,0,1,1,0,0,0,1.84.76,6.58,6.58,0,0,0,.52-2.59A6.79,6.79,0,1,0,8.38,11.38,1,1,0,0,0,9.31,12Z"/>';
var PressOutlineSVG = function PressOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PressOutlineSVG = PressOutlineSVG;
PressOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PressOutlineSVG);
exports.default = _default;